import React from 'react'
import ContainerLayout from '../../../../components/container-layout/ContainerLayout'
import { Box, Typography } from '@mui/material'
import { banner_group_data } from './enum/enum'
import clsx from 'clsx'
import { createSearchParams, useNavigate } from 'react-router-dom'
import { routeName } from '../../../../routes/routeName'
import NavigateListCustom from '../../../../components/navigation/NavigationListCustom'
import { useTranslation } from 'react-i18next'

type Props = {}

const BannerSlideList = ({ }: Props) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const handleNext = (type: string) => {
        navigate({
            pathname: routeName.cms_website.website_structure_banner_slide,
            search: createSearchParams({
                group_type: type
            }).toString()
        })
    }
    return (
        <ContainerLayout
            title=''
            titleName={t('แบนเนอร์สไลด์')}
            navigateContent={
                <NavigateListCustom
                    navigateData={
                        [
                            {
                                key: "โครงสร้างเว็บไซต์", // i18n-ignore
                                name: t("โครงสร้างเว็บไซต์"),
                                pathName: "",
                                disabled_match: true
                            },
                            {
                                key: "website_structure_banner_slide",
                                name: t("แบนเนอร์สไลด์"),
                                pathName: routeName.cms_website.website_structure_banner_slide_list,
                            },
                        ]}
                />
            }
            buttonContent={
                <></>
            }
            content={
                <Box className="w-full rounded-2xl shadow-lg">
                    <Box className="flex flex-col">
                        {banner_group_data.map((list, i) => {
                            return (
                                <Box onClick={() => handleNext(list?.value)} className={clsx('border-slate-100 hover:bg-slate-200 hover:animate-pulse cursor-pointer border-b-2', {
                                    'rounded-t-2xl border-b-0': i === 0,
                                    'border-b-0 rounded-b-2xl': i === banner_group_data.length - 1,
                                })} sx={{ py: "24px", px: "32px" }} key={list.value}>
                                    <Typography variant='h6'>
                                        {t(list.label)}
                                    </Typography>
                                </Box>
                            )
                        })}
                    </Box>
                </Box>
            }
        />
    )
}

export default BannerSlideList